import './LegendLeaflet.css';
import format from 'number-format.js';

const default_cores = [
    '800026',
    'BD0026',
    'E31A1C',
    'FC4E2A',
    'FD8D3C'
];

// const div_marker_portos = "<div class='awesome-marker-icon-purple awesome-marker leaflet-zoom-animated leaflet-interactive' style='margin-left: 6px' position='relative';><i class='fa fa-anchor icon-white'></i></div>";
//const div_marker_portos = "<div class='awesome-marker-icon-purple awesome-marker leaflet-zoom-animated leaflet-interactive' tabindex='0' style='margin-left: -17px; margin-top: -42px; width: 35px; height: 45px; transform: translate3d(1111px, 348px, 0px); z-index: 348; outline: none;'><i class='fa fa-anchor  icon-white'></i></div>";

export const _TIPO_LEGEND_DEFAULT = 1;
export const _TIPO_LEGEND_NATURAL_BREAK = 2;
export const _TIPO_LEGEND_NATURAL_BREAK_PORTOS = 3;

export const format_grades = (grades) => {
    let new_grade = [];
    grades.map(g => {
        let formated = g === 0 ? '0' : format("###,###.#", g);
        var find = ',';
        var re = new RegExp(find, 'g');
        formated = formated.replace(re, '.');
        new_grade.push(formated); // substitui as virgulas por pontos porque o number-format.js não da suporte para lingua br
        return g;
    });
    return [...new_grade];
}

// gera um controle leaflet que apresenta as legendas do array 'grades', e com as cores em 'cores'
export const getLegendLeaflet = (grades, tipo_legend = _TIPO_LEGEND_DEFAULT, cores = default_cores, titulo_legenda = "Titulo da Legenda") => {

    let legend = L.control({ position: 'bottomright' });

    // formata os numeros em milhas se for natural break
    if (tipo_legend === _TIPO_LEGEND_NATURAL_BREAK || tipo_legend === _TIPO_LEGEND_NATURAL_BREAK_PORTOS) {
        grades = format_grades(grades);
    }

    legend.onAdd = function (map) {

        let div = L.DomUtil.create('div', 'info legend');

        // coloca o titulo na legenda
        div.innerHTML += titulo_legenda !== '' ? '<h6>' + titulo_legenda + '</h6><hr>' : '';

        if (tipo_legend === _TIPO_LEGEND_NATURAL_BREAK_PORTOS) {
            for (let i = 0; i < grades.length - 1; i++) {
                div.innerHTML +=
                    '<i style="background-color:#' + cores[i] + '"></i> ' +
                    grades[i] + (grades[i + 1] ? ' &ndash; ' + grades[i + 1] + '<br>' : grades[i + 1]);
            }
        }

        if (tipo_legend === _TIPO_LEGEND_NATURAL_BREAK) {
            for (let i = 0; i < grades.length - 1; i++) {
                div.innerHTML +=
                    '<i style="background:#' + cores[i] + '"></i> ' +
                    grades[i] + (grades[i + 1] ? ' &ndash; ' + grades[i + 1] + '<br>' : grades[i + 1]);
            }
        }

        if (tipo_legend === _TIPO_LEGEND_DEFAULT) {
            for (let i = 0; i < grades.length; i++) {
                div.innerHTML +=
                    '<i style="background:#' + cores[i] + '"></i> ' +
                    grades[i] + (grades[i + 1] ? '<br>' : '');
            }
        }

        return div;
    };

    return legend;

}


// WEBPACK FOOTER //
// ./src/LegendLeaflet.js